export const getPositions = (payload?: any) => ({
    type: "@saga/GET_POSITIONS",
    payload
});

